import { AuthenticationState } from './types';

export const authenticationInitialState: AuthenticationState = {
  mustRefreshAuthentication: false,
};
